/** Lets members browse without finishing email/OTP until tab is closed or they log out. */
export const SKIP_EMAIL_VERIFICATION_SESSION_KEY = "venuelista_skip_email_verify_session";
export const SKIP_PHONE_VERIFICATION_SESSION_KEY = "venuelista_skip_phone_verify_session";

/** Kill switch: SMS providers (Twilio/Telnyx/Infobip) are failing, so nobody gets sent to /verify-phone. Flip back to true once SMS works. */
export const PHONE_VERIFICATION_ENABLED = false;

export function setSkipEmailVerificationForSession(): void {
  try {
    sessionStorage.setItem(SKIP_EMAIL_VERIFICATION_SESSION_KEY, "1");
  } catch {
    /* private mode etc. */
  }
}

export function setSkipPhoneVerificationForSession(): void {
  try {
    sessionStorage.setItem(SKIP_PHONE_VERIFICATION_SESSION_KEY, "1");
  } catch {
    /* private mode etc. */
  }
}

export function clearVerificationGateSkips(): void {
  try {
    sessionStorage.removeItem(SKIP_EMAIL_VERIFICATION_SESSION_KEY);
    sessionStorage.removeItem(SKIP_PHONE_VERIFICATION_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function shouldBypassEmailVerificationGate(): boolean {
  try {
    return sessionStorage.getItem(SKIP_EMAIL_VERIFICATION_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function shouldBypassPhoneVerificationGate(): boolean {
  if (!PHONE_VERIFICATION_ENABLED) return true;
  try {
    return sessionStorage.getItem(SKIP_PHONE_VERIFICATION_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}
